// assets/a24-theme.js
/* Außenborder24 Theme Bootstrap: shared lifecycle helpers and native Shopify Editor state. */
(function () {
  'use strict';

  var A24Theme = window.A24Theme = window.A24Theme || {};

  function getDocumentRoot() {
    return document.documentElement;
  }

  A24Theme.isDesignMode = function () {
    var root = getDocumentRoot();

    return Boolean(
      (root && root.getAttribute('data-a24-design-mode') === 'true') ||
      (window.Shopify && window.Shopify.designMode === true)
    );
  };

  A24Theme.isInspectorActive = function () {
    return Boolean(window.Shopify && window.Shopify.inspectMode === true);
  };

  /*
   * Compatibility helper for existing theme modules.
   * Theme code may pause its own interaction only while Shopify's native Preview
   * Inspector is enabled. It must never intercept, prevent, redispatch, or alter
   * the browser click that Shopify uses to select a section or block.
   */
  A24Theme.shouldProtectEditorClicks = function () {
    return A24Theme.isInspectorActive();
  };

  function syncEditorState() {
    var root = getDocumentRoot();
    if (!root) return;

    root.setAttribute('data-a24-editor-active', A24Theme.isDesignMode() ? 'true' : 'false');
    root.setAttribute('data-a24-inspector-active', A24Theme.isInspectorActive() ? 'true' : 'false');
  }

  syncEditorState();
  window.setTimeout(syncEditorState, 0);

  document.addEventListener('shopify:inspector:activate', syncEditorState);
  document.addEventListener('shopify:inspector:deactivate', syncEditorState);

  A24Theme.onReady = function (callback) {
    if (typeof callback !== 'function') return;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  A24Theme.onSectionLoad = function (callback) {
    if (typeof callback !== 'function') return;

    document.addEventListener('shopify:section:load', function (event) {
      callback(event && event.target ? event.target : document, event);
    });
  };

  // Best-effort image protection: prevent context menu and drag on images.
  // This deters casual downloads but cannot fully prevent saving assets.
  A24Theme.onReady(function () {
    document.addEventListener('contextmenu', function (event) {
      if (A24Theme.isDesignMode()) return;

      var target = event.target;
      var image = target && target.closest ? target.closest('img') : null;
      if (!image) return;

      event.preventDefault();
    }, true);

    document.addEventListener('dragstart', function (event) {
      if (A24Theme.isDesignMode()) return;

      var target = event.target;
      var image = target && target.closest ? target.closest('img') : null;
      if (!image) return;

      event.preventDefault();
    }, true);
  });
}());
